export default "__VITE_ASSET__62qgxZD9__"